export default "__VITE_ASSET__CrYsJStZ__"